export enum PATH {
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  NEW_PASSWORD = '/set-new-password/',
  TOKEN = ':token',
  PAGE404 = '/page404',
  PROFILE = '/profile',
  REGISTRATION = '/registration',
  TEST = '/test',
  CARDS = '/cards',
  CARD = '/card/',
  CARD_ID = ':id',
  CARD_NAME = ':name',
  INSTRUCTION = '/instruction',
}
